import * as React from "react";
import {DataGrid, gridClasses} from "@mui/x-data-grid";
import {Box} from "@mui/material";

export default function DataTable({columns, rows, apiRef}) {
  return (
    <Box sx={{height: "65vh", width: "100%"}}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {page: 0, pageSize: 10},
          },
        }}
        apiRef={apiRef}
        pageSizeOptions={[10, 20]}
        sx={{
          [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]:
            {
              outline: "none",
            },
          [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
            {
              outline: "none",
            },
          border: 0,
        }}
        disableRowSelectionOnClick
      />
    </Box>
  );
}
